import { render, staticRenderFns } from "./UpgradeCuotaCollectiveDialog.vue?vue&type=template&id=4ca15800&scoped=true"
import script from "./UpgradeCuotaCollectiveDialog.vue?vue&type=script&lang=js"
export * from "./UpgradeCuotaCollectiveDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca15800",
  null
  
)

export default component.exports